module.exports = __webpack_public_path__ + "static/media/shopping-cart-light.52b42829.svg";